/** @jsxImportSource @emotion/react */
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import CustomDialog from 'components/modals/common/CustomDialog';
import { useMessageBar } from '../../../hooks/useMessageBar';
import { tb } from '../../../components/layouts/Table';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import _ from 'lodash';
import { Button } from '@mui/material';
import { IconButton } from '../../../components/buttons/IconSVG';
import CustomInputWithSearch from '../../../components/inputs/CustomInputWithSearch';
import { ComboBox } from '../../../components/selects/ComboBox';
import { Code } from '../../../models/common/CommonCode';
import CustomTextarea from '../../../components/inputs/CustomTextarea';

interface Props {
  open: boolean;
  close: (isDone?: boolean) => void;
  title: string;
  initParam: {
    type?: string;
    rmk?: string;
    typeValue: string;
  };
  onCallbackData: any;
}

/**
 * 사유입력팝업
 *       1. DROP - Drop : MP010
 *       2. 개발재검토 : ?
 *       3. DLBR_CPLT -   심의완료(수평전개 재진행): 수평전개 진행 /보류 선택 MP006
 * @param open
 * @param close
 * @param title
 * @param initParam
 * @param onCallbackData
 */
export const MpRemarkPopUp = ({ open, close, title, initParam, onCallbackData }: Props) => {
  const { t } = useTranslation();
  const { openMessageBar } = useMessageBar();

  const [mpRemarkData, setMpRemarkData] = useState<any>({
    rmk: '',
    type: '',
    typeValue: '',
  });

  const [code, setCode] = useState<any>({});

  //init
  useEffect(() => {
    setMpRemarkData({
      rmk: initParam.rmk,
      type: initParam.type,
    });
    getCommonCodes();
  }, [initParam]);

  const getCommonCodes = async () => {
    const cplt: Code[] = [
      { cmnCd: 'PROG', cmnCdNm: '진행' },
      { cmnCd: 'HOLD', cmnCdNm: '보류' },
    ];

    //DLBR_CPLT
    setCode({
      ...code,
      dlbrCplt: cplt,
    });
  };

  const handleConfirm = () => {
    if (mpRemarkData.dlbrCplt !== 'PROG' && _.isEmpty(mpRemarkData.rmk)) {
      openMessageBar({
        type: 'error',
        content: t('com.msg.사유를 입력해주세요.', '사유를 입력해주세요.'),
      });
      return;
    }
    onCallbackData(mpRemarkData);
    close();
  };

  const dialogButtons = [
    <Button
      key={'confirm'}
      css={IconButton.button}
      className="confirm"
      onClick={handleConfirm}
      disableRipple
    >
      {t('com.button.적용', '적용')}
    </Button>,
  ];

  return (
    <>
      <CustomDialog
        title={title}
        open={open}
        onClose={close}
        onCancel={close}
        size={'sm'}
        buttons={dialogButtons}
      >
        <TableContainer css={tb.table} style={{ marginBottom: '50px' }}>
          <Table>
            <TableBody>
              {initParam && initParam?.type == 'DLBR_CPLT' && (
                <TableRow>
                  <TableCell>{t('com.label.유형', '유형')}</TableCell>
                  <TableCell>
                    <ComboBox
                      options={code?.dlbrCplt || []}
                      placeholder={String(t('com.label.선택', '선택'))}
                      defaultValue={mpRemarkData?.typeValue}
                      onChange={(value) => {
                        setMpRemarkData({
                          ...mpRemarkData,
                          typeValue: value,
                        });
                      }}
                      // isError={errors?.mpClsfCd}
                      // msgError={String(
                      //   t('mp.msg.분류를 선택해 주세요.', '분류를 선택해 주세요.')
                      // )}
                    />
                  </TableCell>
                </TableRow>
              )}
              <TableRow>
                <TableCell>
                  <span className={'dot'}>{t('com.label.사유', '사유')}</span>
                </TableCell>
                <TableCell>
                  <CustomTextarea
                    name="rmk"
                    placeholder={String(
                      t('mp.label.사유를 입력해 주세요.', '사유를 입력해 주세요.')
                    )}
                    value={mpRemarkData?.rmk}
                    onChange={(event: any) => {
                      const value = event?.target.value;
                      if (value.length <= 1000) {
                        setMpRemarkData({
                          ...mpRemarkData,
                          rmk: value,
                        });
                      } else {
                        openMessageBar({
                          type: 'error',
                          content: t(
                            'mp.label.사유는 1000자를 넘을 수 없습니다.',
                            '사유는 1000자를 넘을 수 없습니다.'
                          ),
                        });
                      }
                    }}
                  />
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </CustomDialog>
    </>
  );
};
